import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import type { Tester } from "../types";

interface LayoutProps {
  profile: Tester | null;
  isAdmin: boolean;
  onSignOut: () => void;
  children: ReactNode;
}

export function Layout({ profile, isAdmin, onSignOut, children }: LayoutProps) {
  const initials = profile
    ? `${profile.first_name[0] ?? ""}${profile.last_name[0] ?? ""}`.toUpperCase()
    : "??";

  return (
    <div className="min-h-screen bg-[#fafaf7] flex flex-col">
      <header className="bg-white border-b border-zinc-200 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="text-xs font-bold tracking-widest text-rwb-red">TEAM RWB · TESTING</div>
          {isAdmin && (
            <Link
              to="/admin"
              className="text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded bg-rwb-red text-white hover:bg-rwb-redDark transition"
              title="Open admin panel"
            >
              Admin →
            </Link>
          )}
        </div>
        {profile ? (
          <div className="flex items-center gap-3">
            <div
              className="w-7 h-7 rounded-full text-white text-[11px] font-semibold flex items-center justify-center"
              style={{ background: "linear-gradient(135deg, #2b6cb0, #6b46c1)" }}
              title={profile.email}
            >
              {initials}
            </div>
            <button
              onClick={onSignOut}
              className="text-xs text-zinc-500 hover:text-zinc-800 transition"
            >
              Sign out
            </button>
          </div>
        ) : (
          <button
            onClick={onSignOut}
            className="text-xs text-zinc-500 hover:text-zinc-800 transition"
          >
            Sign out
          </button>
        )}
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
